"use client";
import {
  AccountRecovery,
  type AccountRecoveryState,
} from "../account-recovery";
import { Alert, Button, Card, Stack, Text } from "@softmax/design-system";
import type { ReactNode } from "react";
import { PlayerPhotoUpload } from "./player-photo-upload";
import { PlayerIdentity, type AccountPlayer } from "./player-identity";

export function AccountPlayerCard({
  player,
  pending,
  error,
  recovery,
  onRefresh,
  credentials,
  onRename,
  onMakeDefault,
  onUploadAvatar,
  onRemoveAvatar,
}: {
  readonly player: AccountPlayer;
  readonly pending: boolean;
  readonly error?: string;
  readonly recovery?: AccountRecoveryState;
  readonly onRefresh?: () => void;
  readonly credentials: ReactNode;
  readonly onRename: () => void;
  readonly onMakeDefault: () => void;
  readonly onUploadAvatar: (file: File) => void;
  readonly onRemoveAvatar: () => void;
}) {
  return (
    <Card>
      <Stack width="auto">
        <PlayerIdentity
          player={player}
          disabled={pending || !!recovery}
          onRename={onRename}
          onMakeDefault={onMakeDefault}
        />
        <PlayerPhotoUpload
          name={player.name}
          avatarUrl={player.avatarUrl}
          disabled={pending || !!recovery}
          onUploadAvatar={onUploadAvatar}
        />
        {player.avatarUrl ? (
          <div>
            <Button
              size="sm"
              variant="danger"
              onClick={onRemoveAvatar}
              disabled={pending || !!recovery}
            >
              Remove player photo
            </Button>
          </div>
        ) : null}
        {pending ? (
          <output>
            <Text>Updating player…</Text>
          </output>
        ) : null}
        {error ? (
          <Alert tone="danger" announcement="assertive">
            {error}
          </Alert>
        ) : null}
        {recovery ? (
          <AccountRecovery
            recovery={recovery}
            resource="players"
            onRefresh={onRefresh}
          />
        ) : null}
        {credentials}
      </Stack>
    </Card>
  );
}
